import { useTranslation } from '../../../utils/useTranslation';
import { FormControl } from '../../input/FormControl';
import { Radio } from '../../input/Radio';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { BusinessType } from '../types';
import { BusinessTypeTabsProps, TabProps } from './types';

const BusinessTypeTab = ({ isSelected, onClick, title, description, ...other }: TabProps) => (
    <Box
        onClick={onClick}
        p={2}
        pt={1.5}
        borderRadius={2}
        border={isSelected ? '1px solid transparent' : '1px solid var(--divider)'}
        backgroundColor={isSelected ? 'var(--control-secondary-background)' : undefined}
        cursor="pointer"
        boxSizing={'border-box'}
        {...other}
    >
        <FormControl>
            <Radio checked={isSelected} onClick={onClick} />
        </FormControl>
        <Typography variant="body" weight="bold" pt={2}>
            {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
    </Box>
);

export const BusinessTypeTabs = (props: BusinessTypeTabsProps) => {
    const { businessType, onChange, ...other } = props;
    const t = useTranslation();

    return (
        <Flex spacing={1} direction="row" {...other}>
            <BusinessTypeTab
                width="50%"
                height="100%"
                isSelected={businessType === BusinessType.BUSINESS}
                onClick={() => onChange(BusinessType.BUSINESS)}
                title={t('Бизнес-аккаунт')}
                description={t('Для брендов и производителей')}
            />
            <BusinessTypeTab
                width="50%"
                height="100%"
                isSelected={businessType === BusinessType.BLOGGER}
                onClick={() => onChange(BusinessType.BLOGGER)}
                title={t('Автор')}
                description={t('Для тех, кто ведет блог и развивает активное сообщество')}
            />
        </Flex>
    );
};
